/**
 * Selector that retrieves the attempt id for the current question that is being
 * answered by a user (i.e. typing into one of its numeric input fields).
 * If the user is not inputting an answer, returns null
 * @param state
 * @returns {any|*|T}
 */
import { QUESTION_ACTIVITY_KEY } from './reducers';
import { VIEW_STATES_KEY } from '../viewstates/reducers';

/**
 * Gets a question activity by its attempt id
 * @param state
 * @param attemptId
 */
export const getQuestionActivity = (state, attemptId) =>
    state.getIn([QUESTION_ACTIVITY_KEY, 'activities', attemptId]);

/**
 * Gets a question activity id by its attempt id
 * @param state
 * @param attemptId
 */
export const getQuestionActivityId = (state, attemptId) =>
    state.getIn([QUESTION_ACTIVITY_KEY, 'activities', attemptId, 'info', 'question_activity_id']);

/**
 * Gets the stage of an activity from the attempt ID.
 * @param state
 * @param attemptId
 */
export const getQuestionActivityStage = (state, attemptId) =>
    state.getIn([QUESTION_ACTIVITY_KEY, 'activities', attemptId, 'stage']);

/**
 * Gets all of the question activities.
 * @param state
 */
export const getQuestionActivities = state => state.getIn([QUESTION_ACTIVITY_KEY, 'activities']);

/**
 * Selects the first question activity for a taskItemId.
 * @param state
 * @param taskItemId
 * @returns {*}
 */
export const getQuestionActivityForTaskItem = (state, taskItemId) =>
    getQuestionActivities(state).findKey(act => act.get('taskItemId') === taskItemId);

/**
 * Selector determines whether the active question has been submitted already
 * @param state
 * @returns {any|T|*}
 */
export const isActiveQuestionSubmitted = attemptId => state =>
    state.getIn([QUESTION_ACTIVITY_KEY, 'activities', attemptId, 'submitted'], false);

/**
 * Gets the attempt ID of the question that's currently in progress.
 */
export const getShowingQuestionAttemptId = state =>
    state.getIn([VIEW_STATES_KEY, 'skilldelivery', 'attemptId']);

/**
 * Selector that returns the question info for the question that is currently
 * active in the skill delivery view, or null if the skill delivery view is not
 * present
 */
export const getShowingQuestion = state => {
    const attemptId = getShowingQuestionAttemptId(state);

    if (!attemptId) {
        return null;
    }

    return state.getIn([QUESTION_ACTIVITY_KEY, 'activities', attemptId, 'info']);
};
